
import React, { useState, useEffect, useRef } from "react";
import PopupForm from "../../../Components/PopupForm";
import { useTranslation } from "react-i18next";
import unitObject, { objectMerge } from "../../../Errors/MainUnits/MainUnit";
import Cookies from "universal-cookie";
import { Box, Button, FormControlLabel, Grid, Switch } from "@mui/material";
import CustomTextField from "../../../Components/CustomTextField";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import mainUnitApi from "../../../Network/MainUnit";
import MainUnitSubscriptionLogs from "./MainUnitSubscriptionLogs";
import { useSelector } from "react-redux";
const cookies = new Cookies();



export default function SubscribeFormContainer(props) {
  const [t] = useTranslation("common");
  const navigate = useNavigate();
  const [reload, setReload] = useState(false)
  const [unit, setUnit] = useState(unitObject);
  const maintheme = useSelector((state) => state.themeData.maintheme);


  const clearForm = () => {
    setUnit(unitObject)
  };
  useEffect(() => {
    if (!props?.object) {
      clearForm();

    } else {
      const mergedObject = objectMerge(props?.object)
      setUnit(mergedObject)
    }

  }, [props?.openForm, props?.object]);



  const submit = async (closeForm) => {
    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      try {



        let checkErrorObject = {
          ...unit
        }
        let hasError = false
        let readyToSendObject = {}


        if (!unit?.is_subscribed_note?.value) {

          hasError = true


          checkErrorObject['is_subscribed_note']['error'] = true
          checkErrorObject['is_subscribed_note']['message'] = [t('GLOBAL.mandatory_field')]

        }


        if (hasError) {
          setUnit({
            ...checkErrorObject
          })
          return
        }

        readyToSendObject['is_subscribed'] = unit?.is_subscribed?.value
        readyToSendObject['is_subscribed_note'] = unit?.is_subscribed_note?.value
        readyToSendObject['main_unit_id'] = props?.object?.id


        let params = {
          username: cookies.get("user_name"),
          user_id: cookies.get("user_id"),
          account_name: cookies.get("account_name"),
          account_id: cookies.get("account_id"),
          sid: cookies.get("sid"),
          baseurl: cookies.get("baseUrl"),
          id: cookies.get("id"),
        };

        let result = await mainUnitApi.addSubscriptionLog({
          data: readyToSendObject,
          params: params,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });


        if (result?.status && result?.data?.status) {
          toast.success(t("NETWORK_MESSAGES.infoAddedSuccessfully"));
          props.loadData();
          setReload(!reload)
          clearForm()
          if (closeForm) {
            props.setOpenForm(false);
          }

        } else {



          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }

          else {

            toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
          }
        }
      } catch (error) {

        toast.error(error.message);
      }
    } else {

      // navigate('/redirect')
    }
  };



  return (
    <PopupForm
      open={props?.openForm}
      setOpen={props?.setOpenForm}
      title={t("UNITS.subscription_logs")}
      isFullScreen={false}

      content={<Box className="Container-fluid position-relative" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} sx={{
          marginTop: '10px'
        }}>
          <Grid xs={6} sm={6} md={6} lg={6} sx={{
            padding: '0px'
          }}>
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                // borderRadius:'10px',
                height: '55px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                width: '93% !important',
                boxShadow: '0px 6px 20px 3px #00000014 !important',
                margin: 'auto',
                marginTop: '5px',
                marginBottom: '5px',
                paddingLeft: '15px',
                "& .MuiTypography-root": {
                  fontFamily: 'Cairo-Medium'
                }

              }}
            >
              <FormControlLabel control={<Switch checked={unit?.is_subscribed?.value == 1} onChange={(e) => {

                setUnit({
                  ...unit,
                  is_subscribed: {
                    ...unit?.is_subscribed,
                    value: e.target.checked,
                    error: false,
                    message: []
                  }
                })
              }} />} sx={{ fontFamily: 'Cairo-Medium' }} label={unit?.is_subscribed?.value ? t('UNITS.subscribed') : t('UNITS.not_subscribed')} />
            </Box>

          </Grid>
          <Grid xs={6} sm={6} md={6} lg={6} sx={{
            padding: '0px'
          }}>
            <CustomTextField
              label={t("UNITS.is_subscribed_note")}
              hasMultipleLine={true}
              error={unit?.is_subscribed_note?.error}
              message={unit?.is_subscribed_note?.message}
              onChange={(e) => {
                setUnit({
                  ...unit,
                  is_subscribed_note: {
                    ...unit?.is_subscribed_note,
                    value: e.target.value,
                    error: false,
                    message: []
                  }
                })
              }}
              value={unit?.is_subscribed_note?.value}
              haswidth={true}
              readOnly={false}
              onClearClick={() => {

                setUnit({
                  ...unit,
                  is_subscribed_note: {
                    ...unit?.is_subscribed_note,
                    value: "",
                    error: false,
                    message: []
                  }
                })
              }}
            />
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} sx={{
            padding: '0px',

          }}>
            <Box sx={{
              paddingTop: '10px'
            }}>
              <MainUnitSubscriptionLogs
                reload={reload}
                mainUnitId={props?.object?.id}
              />
            </Box>

          </Grid>
        </Grid>

      </Box>

      }
      footer={
        <Box>
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#d1d0d0",
              borderColor: "#ffffff",
              color: "#000000",
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,

              "&:hover": {
                backgroundColor: maintheme?.secondary,
                borderColor: "#ffffff",
                color: "#fff",
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {

              props?.setOpenForm(false);
            }}
          >
            {t("GLOBAL.close")}
          </Button>
          <Button

            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "120px !important",
              minWidth: "120px !important",
              maxWidth: "120px !important",
              backgroundColor: maintheme?.secondary,
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              const closeForm = true
              submit(closeForm);
            }}
          >
            {t("GLOBAL.Save_and_close")}
          </Button>
          <Button

            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              backgroundColor: maintheme?.secondary,
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              submit();
            }}
          >
            {t("GLOBAL.Save")}
          </Button>
        </Box>

      }
    />
  );
}
